import React from "react";
import PageHeader from "@/components/PageHeader";
import Hero from "@/components/Hero";
import IntroVideo from "@/components/IntroVideo";
import TrustPillars from "@/components/TrustPillars";
import RegionalCoverage from "@/components/RegionalCoverage";
import CarrierStrip from "@/components/CarrierStrip";
import ClosingBand from "@/components/ClosingBand";
import FooterBar from "@/components/FooterBar";
import useSeo from "@/lib/useSeo";
import { COMPANY } from "@/lib/compliance";

// LocalBusiness / InsuranceAgency Schema.org JSON-LD. Injected into <head>
// so search engines can surface rich-result data (phone, email, areaServed).
const INSURANCE_AGENCY_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "InsuranceAgency",
    name: COMPANY.legalName,
    legalName: COMPANY.fullLegalName,
    url: COMPANY.website,
    telephone: COMPANY.phoneTel,
    email: COMPANY.email,
    address: {
        "@type": "PostalAddress",
        streetAddress: "59 Hollow Rd",
        addressLocality: "Stony Brook",
        addressRegion: "NY",
        postalCode: "11790",
        addressCountry: "US",
    },
    areaServed: [
        { "@type": "State", name: "New York" },
        { "@type": "State", name: "New Jersey" },
        { "@type": "State", name: "Pennsylvania" },
        { "@type": "State", name: "Connecticut" },
        { "@type": "State", name: "North Carolina" },
        { "@type": "State", name: "Florida" },
        { "@type": "State", name: "Texas" },
    ],
};

const SCHEMA_NODE_ID = "ldjson-insurance-agency";

function useInsuranceAgencySchema() {
    React.useEffect(() => {
        let script = document.getElementById(SCHEMA_NODE_ID);
        if (!script) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = SCHEMA_NODE_ID;
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(INSURANCE_AGENCY_SCHEMA);
        return () => {
            const node = document.getElementById(SCHEMA_NODE_ID);
            if (node) node.remove();
        };
    }, []);
}

export default function LandingPage() {
    useSeo({
        title: "Multi-State Independent Insurance Agency",
        description:
            "Independent insurance agency serving NY, NJ, PA, CT, NC, FL, and TX. Personal, business, life, health, and cyber coverage with a licensed agent on call.",
        canonicalPath: "/",
    });
    useInsuranceAgencySchema();

    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen overflow-x-hidden bg-brand-bg text-brand-ivory"
        >
            <PageHeader />
            <Hero />
            <IntroVideo />
            <TrustPillars />
            <RegionalCoverage />
            <CarrierStrip />
            <ClosingBand />
            <FooterBar />
        </main>
    );
}
